import React from 'react';
import * as Icons from 'lucide-react';

// Renders a lucide icon by string name
export default function Icon({ name, ...props }) {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp {...props} />;
}
